import {
  FeedbackMetadataGrid,
  FeedbackMetadataGroupedByObjectID,
  FeedbackMetadataTypeHeader,
} from '@modules/feedback/components/FeedbackMetadata';
import {
  getFeedbackSourceMetadataGroupedByObjectID,
  getSortedFeedbackSourceMetadataFields,
} from '@modules/feedback/utils';
import { Box, Divider, Stack } from '@mui/material';
import { ObjectType } from 'generated/graphql';
import { Feedback } from 'v2/core/entities/feedback';

interface FeedbackCardMetadataExpandedViewProps {
  feedback: Feedback;
}

export const FeedbackCardMetadataExpandedView = ({
  feedback,
}: FeedbackCardMetadataExpandedViewProps) => {
  const metadataFields = getSortedFeedbackSourceMetadataFields({
    metadataFields: feedback.sourceV2?.metadata,
  });

  const renderMetadataFieldsForObjectType = (objectType: ObjectType) => {
    const objectTypeMetadataFields = metadataFields.filter(
      (metadataField) => metadataField.objectType === objectType,
    );

    if (objectTypeMetadataFields.length === 0) {
      return null;
    }

    const groupedByObjectID = getFeedbackSourceMetadataGroupedByObjectID({
      metadataFields: objectTypeMetadataFields,
    });
    const objectIDCount = Object.keys(groupedByObjectID).length;
    const shouldShowGroupedView = objectIDCount > 1;

    return (
      <Stack spacing={2}>
        <FeedbackMetadataTypeHeader
          objectType={objectType}
          objectIDCount={objectIDCount}
        />
        <Box>
          {shouldShowGroupedView ? (
            <FeedbackMetadataGroupedByObjectID
              metadataFields={objectTypeMetadataFields}
              groupedByObjectID={groupedByObjectID}
              objectType={objectType}
              gridColumns={4}
              feedbackID={feedback.id}
            />
          ) : (
            <FeedbackMetadataGrid
              metadataFields={objectTypeMetadataFields}
              gridColumns={4}
              disablePadding
              shouldLimitGridItems={false}
              feedbackID={feedback.id}
              objectType={objectType}
            />
          )}
        </Box>
        {!shouldShowGroupedView && <Divider />}
      </Stack>
    );
  };

  return (
    <Stack spacing={3} py={1}>
      {renderMetadataFieldsForObjectType(ObjectType.Feedback)}
      {renderMetadataFieldsForObjectType(ObjectType.User)}
      {renderMetadataFieldsForObjectType(ObjectType.Account)}
    </Stack>
  );
};
